<div class="{{isCustomCompute? 'row compute-div' : 'row'}}">
  @if (isCustomCompute) {
    <div class="six columns">
      <div class="row">
        <div class="field">
          <label soho-label [required]="true">{{'FieldNameLabel' | translate}}</label>
          <input type="text"
            id="customComputeName"
            name="customComputeName"
            class="input-md"
            soho-input
            (ngModelChange)="handleFieldNameEvent($event)"
            soho-alert
            #fieldName
            [ngModel]="customCompute.fieldName"
            data-automation-id="lm-compute-builder-field-name">

          </div>
        </div>
        <div class="row">
          <div class="compound-field">
            <div class="field"><label soho-label [required]="true">{{'FieldType' | translate}}</label>
            <select
              soho-dropdown
              [ngClass]="'dropdown-sm'"
              (ngModelChange)="handleFieldType($event)"
              noSearch
              id="customComputeFieldType"
              name="customComputeFieldType"
              placeholder="Field Type"
              soho-alert
              #fieldType
              [ngModel]="customCompute.fieldType"
              [attributes]="fieldTypeDropdownAttributes">
              @for (option of fieldTypes; track option) {
                <option [value]="option.value">{{option.label}}</option>
              }
            </select>
          </div>
          <div class="field">
            <label soho-label [required]="!isSizeReadOnly">{{'SizeLabel' | translate}}</label>
            <input type="text"
              id="customComputeSize"
              name="customComputeSize"
              class="input-sm"
              maxlength="2"
              soho-input
              [readonly]="isSizeReadOnly"
              (ngModelChange)="handleSizeEvent($event)"
              soho-alert
              #size
              [ngModel]="customCompute.size"
              soho-mask
              [mode]="'number'"
              data-automation-id="lm-compute-builder-size">
            </div>
            <div class="field">
              <label soho-label [required]="!isDecimalReadOnly">{{'DecimalsLabel' | translate}}</label>
              <input type="text"
                id="customComputeDecimal"
                name="customComputeDecimal"
                class="input-sm"
                maxlength="1"
                soho-input
                [readonly]="isDecimalReadOnly"
                (ngModelChange)="handleDecimalEvent($event)"
                soho-alert
                #decimal
                [ngModel]="customCompute.decimal"
                soho-mask
                [mode]="'number'"
                data-automation-id="lm-compute-builder-decimal"
                >
              </div>
            </div>
          </div>
        </div>
      }
      <div class="{{isCustomCompute ? 'five columns': 'seven columns' }}">
        <div class="field">
          <label>{{ 'PreviewLabel' | translate }}</label>
          <textarea #computePreview
            style="{{isCustomCompute ? 'min-height: 120px; width: 100%; max-width: none':  'min-height: 38px; width: 100%; max-width: none'}}"
            spellcheck="false"
            tabindex="-1"
            soho-textarea
            soho-alert
            id="computePreview"
            name="computePreview"
            attr.bindId="'computePreview'"
            readonly="true"
            [resizable]="true"
            (keydown)="false"
            [(ngModel)]="generatedComputeLpl"
            data-automation-id="lm-compute-builder-preview"
          ></textarea>
        </div>
      </div>
      <div class="field one columns">
        <div class="label">
          &nbsp;
        </div>
        <button
          soho-button="modal-primary"
          icon="copy"
          title="{{ 'Copy' | translate }}"
          (click)="copyToClipboard(computePreview)"
          data-automation-id="lm-compute-builder-copy-button"
        >{{ 'Copy' | translate }}</button>
      </div>
    </div>
    <div class="row scrollable-flex-shrink" style="max-height: 15em; align-content: center">
      @for (data of computeRows; track data; let i = $index, isFirst = $first, isLast = $last) {
        <lm-compute-builder-row
          [computeRow]="data"
          [businessClass]="businessClass"
          [lookupUrl]="lookupUrl"
          [index]="i"
          [isFirst]="isFirst"
          [isLast]="isLast"
          [fieldSearchUrl]="fieldSearchUrl"
          [lplValidationUrl]="lplValidationUrl"
          [includeAuditFields]="includeAuditFields"
          [fieldPickerMode]="fieldPickerMode"
          (removeRowEvent)="onRemoveButtonEvent($event, isFirst)"
          (computeRowUpdate)="onComputeRowUpdate()"
          (addNewRowEvent)="onAddNewRowEvent()"
          >
        </lm-compute-builder-row>
      }
    </div>

